module.exports = __webpack_public_path__ + "static/media/PageNotFound.419b4538.jpg";